import React from 'react';
import cn from 'classnames';
import _ from 'lodash';

import { formatPrice } from '../../helpers/url_data_agent_live_matches_helpers';
import { getUrlDataLink } from '../../helpers/url_data_helpers';
import SafeImage from '../PinMatchSilentEval/SafeImage';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './LinkCardPage.scss';

const AVAILABILITY = {
  in_stock: { label: 'In stock', className: 'in-stock' },
  sold: { label: 'Sold', className: 'sold' },
  out_of_stock: { label: 'Out of stock', className: 'out-of-stock' }
};
const MORE_PHOTOS_LIMIT = 3;

/** What the creator linked: the page as we read it, or the link itself when we couldn't read it. */
const LinkCardPage = () => {
  const { link, setSite } = useLinksToCheckContext();
  const { page, url, domain, creatorPin } = link;

  // Display data
  const isReadable = page?.readable !== false;
  const availability = AVAILABILITY[page?.availability];
  const facts = [formatPrice(page?.price, page?.currency), page?.variant].filter(Boolean).join(' · ');
  const morePhotos = _.uniq(page?.images || []).filter(source => source && source !== page.image).slice(0, MORE_PHOTOS_LIMIT);
  const pageLink = getUrlDataLink({ sampleUrl: url });
  const linkWords = getLinkWordList(link.linkWords);

  return (
    <div className='links-to-check-card-page'>
      <div className='side-label'>
        <span>The page</span>
        <span>{isReadable ? 'what the creator linked' : 'we couldn’t read it'}</span>
      </div>
      <div className='page-block'>
        <div className='page-photo'>
          <SafeImage className='ltc-photo-image' source={isReadable ? page?.image : null} alt='' placeholderText={isReadable ? 'No photo from the page' : 'The site wouldn’t let us in'} />
          {availability?.className === 'sold' && <span className='page-ribbon'>Sold</span>}
        </div>
        <div className='page-info'>
          {page?.brand && <div className='page-brand'>{page.brand}</div>}
          {isReadable && page?.title && <div className='page-title'>{page.title}</div>}
          {isReadable && facts && <div className='page-facts'>{facts}</div>}
          {isReadable && availability && <span className={cn('page-stock', availability.className)}>{availability.label}</span>}
          {!isReadable && (
            <>
              <div className='page-muted'>Words in the link</div>
              {linkWords.length ? (
                <div className='page-words'>
                  {linkWords.map((word, index) => (
                    <span key={`${word}-${index}`}>{word}</span>
                  ))}
                </div>
              ) : (
                <div className='page-facts'>None we can read</div>
              )}
            </>
          )}
          <div className='page-url' title={url}>
            {url?.replace(/^https?:\/\//, '')}
          </div>
          <div className='page-links'>
            <button type='button' className='page-link' title={`Show only ${domain} links`} onClick={() => setSite(domain)}>
              {domain}
            </button>
            {pageLink && (
              <a className='page-link' href={pageLink} target='_blank' rel='noopener noreferrer'>
                Open page ↗
              </a>
            )}
          </div>
          {!isReadable && creatorPin && (
            <div className='page-pin'>
              <div className='page-pin-photo'>
                <SafeImage className='ltc-photo-image' source={creatorPin.image} alt='' placeholderText='' />
              </div>
              <div>
                <div className='page-muted'>The newest creator pin calls it</div>
                <div className='page-pin-title'>“{creatorPin.title}”</div>
              </div>
            </div>
          )}
        </div>
      </div>
      {isReadable && morePhotos.length > 0 && (
        <div className='page-more-photos'>
          {morePhotos.map(source => (
            <div key={source} className='page-more-photo'>
              <SafeImage className='ltc-photo-image' source={source} alt='' placeholderText='' />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LinkCardPage;

const getLinkWordList = linkWords => (linkWords || '').split(' ').filter(Boolean);
